export enum CodePageStatusEnum {
    ERROR = "error",
    IDLE = "idle",
    LOADING = "loading",
    SUCCESS = "success",
}

export enum ResultPageStatusEnum {
    ERROR = "error",
    LOADING = "loading",
    SUCCESS = "success",
}
